import { animate, state, style, transition, trigger } from '@angular/animations';
import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/primeng';
import { AppComponent } from './app.component';
import { AuthenticationService } from "./services/authentication/authentication.service";

@Component({
	selector: 'app-menu',
	template: `
        <ul app-submenu [item]="model" root="true" class="navigation-menu" visible="true"></ul>
    `
})
export class AppMenuComponent implements OnInit {

	model: any[];

	constructor(public app: AppComponent, private authService: AuthenticationService) { }

	ngOnInit() {
		this.model = [];

		if (this.app.isAdmin()) {
			this.model.unshift({ label: 'Dashboard', icon: 'fa fa-fw fa-dashboard', routerLink: ['/dashboard'] });
			this.model.push({
					label: 'Users',
					icon: 'fa fa-fw fa-user',
					items: [
						{ label: 'Search', icon: 'fa fa-fw fa-search', routerLink: ['/users'] },
						{ label: 'Create', icon: 'fa fa-fw fa-plus', routerLink: ['/users/create'] }
					]
			});

			this.model.push({
				label: 'Subscriptions',
				icon: 'fa fa-fw fa-tasks',
				items: [
					{ label: 'Plans', icon: 'fa fa-fw fa-file', routerLink: ['/subscriptions/plans'] }
				]
			});

			this.model.push({
				label: 'Teams',
				icon: 'fa fa-fw fa-group',
				items: [
					{ label: 'Search', icon: 'fa fa-fw fa-search', routerLink: ['/teams'] },
				]
		});

			this.model.push({
				label: 'Notifications',
				icon: 'fa fa-fw fa-bell',
				items: [
					{ label: 'Search', icon: 'fa fa-fw fa-search', routerLink: ['/notification'] },
					{
						label: 'Default Settings',
						icon: 'fa fa-fw fa-bell',
						routerLink: ['/notification/types']
					}]
			});

			this.model.push();

			this.model.push({
				label: "Businesses",
				icon: 'fa fa-fw fa-address-card',
				items: [
					{ label: 'Search', icon: 'fa fa-fw fa-search', routerLink: ['/businesses'] },
				]
			})

			this.model.push({
				label: 'Tenders',
				icon: 'fa fa-fw fa-file',
				items: [
					{ label: 'Search', icon: 'fa fa-fw fa-search', routerLink: ['/tenders'] },
					{ label: 'Create', icon: 'fa fa-fw fa-plus', routerLink: ['/tenders/create'] },
				]
			});

			this.model.push({
				label: 'Business Categories',
				icon: 'fa fa-fw fa-object-group',
				items: [
					{ label: 'Search', icon: 'fa fa-fw fa-search', routerLink: ['/business-category'] },
					{ label: 'Create', icon: 'fa fa-fw fa-plus', routerLink: ['business-category/create'] },
					{ label: 'Interests', icon: 'fa fa-fw fa-sitemap', routerLink: ['/interests'] },
				]
			});

			this.model.push({
				label: 'Events',
				icon: 'fa fa-fw fa-calendar-o',
				items: [
					{ label: 'Search', icon: 'fa fa-fw fa-search', routerLink: ['/events'] },
					{ label: 'Create', icon: 'fa fa-fw fa-plus', routerLink: ['/events/create'] },
				]
			});

			this.model.push({
				label: "Adverts",
				icon: "fa fa-fw fa-tags",
				items: [
					{ label: "Search", icon: "fa fa-fw fa-search", routerLink: ['/adverts'] },
					{ label: "Create", icon: "fa fa-fw fa-plus", routerLink: ['/adverts/create'] }
				]
			});

			this.model.push({
				label: "Adverts Orders",
				icon: "fa fa-fw fa-brands fa-font-awesome",
				items: [
					{ label: "Search", icon: "fa fa-fw fa-search", routerLink: ['/advert-order'] },
				]
			});


			this.model.push({
				label: "Ads Pricing",
				icon: "fa fa-fw fa-cc-visa",
				items: [
					{ label: "Search", icon: "fa fa-fw fa-search", routerLink: ['/ads-pricing'] },
				]
			});


			this.model.push({
				label: "Ads Coupons",
				icon: "fa fa-fw fa-fire",
				items: [
					{ label: "Search", icon: "fa fa-fw fa-search", routerLink: ['/ads-coupons'] },
				]
			});

			this.model.push({
				label: "Marketplace",
				icon: "fa fa-fw fa-opencart",
				items: [
					{ label: "Coupons", icon: "fa fa-fw fa-btc", routerLink: ['/marketplace/listing-coupons'] },
					{ label: "Couriers", icon: "fa fa-fw fa-truck", routerLink: ['/marketplace/courier-services'] },
					{ label: "Listing Categories", icon: "fa fa-fw fa-table", routerLink: ['/marketplace/listing-category/group'] },
					{ label: "Listing Options", icon: "fa fa-fw fa-sort", routerLink: ['/marketplace/listing-options'] },
				]
			});

			this.model.push({
				label: 'Campaigns',
				icon: 'fa fa-fw fa-star',
				items: [
					{ label: 'Search', icon: 'fa fa-fw fa-star', routerLink: ['/campaigns'] },
					{ label: 'Create', icon: 'fa fa-fw fa-plus', routerLink: ['/campaigns'] }
				]
			});

			this.model.push({
				label: "Funding",
				icon: "fa fa-fw fa-exchange",
				items: [
					{ label: "Search", icon: "fa fa-fw fa-search", routerLink: ['/funding'] },
				]
			});
			this.model.push({
				label: "Rewards",
				icon: "fa fa-fw fa-trophy",
				items: [
					{ label: "Search", icon: "fa fa-fw fa-search", routerLink: ['/rewards'] },
					{ label: "Create", icon: "fa fa-fw fa-plus", routerLink: ['/rewards/create'] }
				]
			});
			this.model.push({
				label: "Books",
				icon: "fa fa-fw fa-book",
				items: [
					{ label: "Search", icon: "fa fa-fw fa-search", routerLink: ['/books'] },
					{ label: "Create", icon: "fa fa-fw fa-plus", routerLink: ['/books/create'] }
				]
			});
			this.model.push({
				label: "Post Templates",
				icon: "fa fa-fw fa-sticky-note-o",
				items: [
					{ label: "Search", icon: "fa fa-fw fa-search", routerLink: ['/post-templates'] },
					{ label: "Create", icon: "fa fa-fw fa-plus", routerLink: ['/post-templates/create'] }
				]
			});

			this.model.push({
				label: 'Manage Feedback',
				icon: 'fa fa-fw fa-list-alt',
				items: [
					{ label: 'Search', icon: 'fa fa-fw fa-search', routerLink: ['/feedback/manage'] }
				]
			});

			this.model.push({
				label: 'Coupons',
				icon: 'fa fa-fw fa-gift',
				items: [
					{ label: 'Search', icon: 'fa fa-fw fa-search', routerLink: ['/coupons'] },
					{ label: "Create", icon: "fa fa-fw fa-plus", routerLink: ['/coupons/create'] }
				]
			});

			this.model.push({
				label: 'Flash',
				icon: 'fa fa-fw fa-ticket',
				items: [
					{ label: 'Groups', icon: 'fa fa-fw fa-group', routerLink: ['/flash/groups'] },
					{ label: 'Products', icon: 'fa fa-fw fa-product', routerLink: ['/flash/products'] },
					{ label: 'Coupons', icon: 'fa fa-fw fa-gift', routerLink: ['/flash/coupons'] }
				]
			});

			this.model.push({
				label: 'Invoice Themes',
				icon: 'fa fa-fw fa-themeisle',
				items: [
					{ label: 'Search', icon: 'fa fa-fw fa-search', routerLink: ['/invoice-theme'] },
					{ label: 'Create', icon: 'fa fa-fw fa-plus', routerLink: ['/invoice-theme/create'] },
				]
			});

			this.model.push({
				label: 'Board Themes',
				icon: 'fa fa-fw fa-trello',
				items: [
					{ label: 'Search', icon: 'fa fa-fw fa-search', routerLink: ['/board-themes'] },
					{ label: 'Create', icon: 'fa fa-fw fa-plus', routerLink: ['/board-themes/create'] },
				]
			});

			this.model.push({
				label: 'Competitions',
				icon: 'fa fa-fw fa-trophy',
				items: [
					{ label: 'Search', icon: 'fa fa-fw fa-search', routerLink: ['/competitions'] },
					{ label: "Create", icon: "fa fa-fw fa-plus", routerLink: ['/competitions/create'] }
				]
			});

			this.model.push({
				label: 'Reporting',
				icon: 'fa fa-fw fa-comment',
				items: [
					{ label: 'Programs', icon: 'fa fa-fw fa-search', routerLink: ['/programs'] }
				]
			});

			
			this.model.push({
				label: 'Apps',
				icon: 'fa fa-fw fa-windows',
				items: [
					{ label: 'Apps', icon: 'fa fa-fw fa-search', routerLink: ['/app-releases'] }
				]
			});
		}
	}
	
	changeTheme(theme) {
		this.app.theme = theme;
		const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
		const layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('layout-css');

		themeLink.href = 'assets/theme/theme-' + theme + '.css';
		layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';

	}
}

@Component({
	/* tslint:disable:component-selector */
	selector: '[app-submenu]',
	/* tslint:enable:component-selector */
	template: `
        <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
            <li [ngClass]="{'active-menuitem': isActive(i)}" [class]="child.badgeStyleClass" *ngIf="child.visible === false ? false : true">
                <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" *ngIf="!child.routerLink"
                   [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target"
                    (mouseenter)="hover=true" (mouseleave)="hover=false">
                    <i [ngClass]="child.icon"></i>
                    <span>{{child.label}}</span>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                    <i class="fa fa-fw fa-angle-down" *ngIf="child.items"></i>
                </a>

                <a (click)="itemClick($event,child,i)" *ngIf="child.routerLink"
                    [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink"
                   [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target"
                    (mouseenter)="hover=true" (mouseleave)="hover=false">
                    <i [ngClass]="child.icon"></i>
                    <span>{{child.label}}</span>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                    <i class="fa fa-fw fa-angle-down" *ngIf="child.items"></i>
                </a>
                <ul app-submenu [item]="child" *ngIf="child.items" [@children]="isActive(i) ?
                'visible' : 'hidden'" [visible]="isActive(i)"></ul>
            </li>
        </ng-template>
    `,
	animations: [
		trigger('children', [
			state('hidden', style({
				height: '0px'
			})),
			state('visible', style({
				height: '*'
			})),
			transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
			transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
		])
	]
})
export class AppSubMenuComponent {
	@Input() item: MenuItem;
	@Input() root: boolean;
	@Input() visible: boolean;
	activeIndex: number;
	hover: boolean;
	constructor(public app: AppComponent, public router: Router, public location: Location) { }

	itemClick(event: Event, item: MenuItem, index: number)  {
		// avoid processing disabled items
		if (item.disabled) {
			event.preventDefault();
			return true;
		}

		// activate current item and deactivate active sibling if any
		this.activeIndex = (this.activeIndex === index) ? null : index;

		// execute command
		if (item.command) {
			item.command({ originalEvent: event, item: item });
		}

		// prevent hash change
		if (item.items || (!item.url && !item.routerLink)) {
			event.preventDefault();
		}

		// hide menu
		if (!item.items && (this.app.overlay || !this.app.isDesktop())) {
			this.app.sidebarActive = false;
		}
	}

	isActive(index: number): boolean {
		return this.activeIndex === index;
	}

	unsubscribe(item: any) {
		if (item.eventEmitter) {
			item.eventEmitter.unsubscribe();
		}

		if (item.items) {
			for (const childItem of item.items) {
				this.unsubscribe(childItem);
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/app.menu.component.ts